import type { Campaign } from '../campaignsApi';
import { campaignChannels, channelLabel } from '../campaignChannels';
import { campaignChannelStatus } from '../campaignStatusPresentation';
import './campaign-status-badge.css';

export function CampaignChannelStatuses({ campaign }: { campaign: Campaign }) {
  return <div className="campaign-channel-statuses" aria-label="Status por origem">
    {campaignChannels(campaign).map(channel => {
      const status = campaignChannelStatus(campaign, channel);
      const confirmed = channel === 'meta' ? campaign.meta_confirmed_status : campaign.google_confirmed_status;
      const error = channel === 'meta' ? campaign.meta_status_check_error : campaign.google_status_check_error;
      const checkedAt = channel === 'meta' ? campaign.meta_status_checked_at : campaign.google_status_checked_at;
      const title = error || (checkedAt ? `Consultado em ${new Date(checkedAt).toLocaleString('pt-BR')}.` :
        confirmed ? 'Última confirmação registrada na origem. Consulte novamente para atualizar.' : undefined);
      return <span key={channel} className="campaign-status-badge" data-tone={status.tone}
        title={title}>
        <span className="campaign-status-dot" aria-hidden="true" />{channelLabel(channel)}: {status.label}
      </span>;
    })}
  </div>;
}
